export const getStickImageStyles = (index, total, multiplicator = 1) => {
    if (total <= 1)
        return {}; // Return no style if total is 1 or less
    const percentage = index / (total - 1);
    const scaledPercentage = percentage * 2 - 1; // Scale the percentage from 0% to 100% to -1 to 1
    let finalPercentage = scaledPercentage * multiplicator; // Scale the range from -multiplicator to multiplicator
    if (total === 2) {
        // For 2 packs of sticks don't use all height of container
        finalPercentage = finalPercentage / 2;
    }
    return {
        marginTop: `${finalPercentage * 100}%`,
    };
};
//# sourceMappingURL=getStickImageStyles.js.map